import React from 'react';
import MobileOrderCard from './MobileOrderCard';
import OrderTableFooter from './OrderTableFooter';

const MobileOrderList = ({
  orders,
  getAllowedStatusOptions,
  getStatusInfo,
  handleOrderSelection,
  openDropdown,
  handleToggleDropdown,
  dropdownPosition,
  handleStatusChange,
  formatDate,
  getClientFullName,
  handleDeleteOrder,
  selectedOrders,
  newlyAddedOrders,
  isFooterExpanded,
  toggleFooterExpand,
  formatPrice,
  handleCallStatusChange // Add this prop
}) => {
  return (
    <div id="mobile-order-list" className="lg:hidden">
      <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
        {orders.map((order) => {
          const allowedOptions = getAllowedStatusOptions(order.etat);
          const statusInfo = getStatusInfo(order.etat);
          const isSelectableStatus = true;
          const isSelected = selectedOrders?.some(selected => selected.id === order.id) || false;

          return (
            <MobileOrderCard
              key={order.id}
              order={order}
              statusInfo={statusInfo}
              allowedOptions={allowedOptions}
              isSelectableStatus={isSelectableStatus}
              isSelected={isSelected}
              handleOrderSelection={handleOrderSelection}
              openDropdown={openDropdown}
              handleToggleDropdown={handleToggleDropdown}
              dropdownPosition={dropdownPosition}
              handleStatusChange={handleStatusChange}
              formatDate={formatDate}
              getClientFullName={getClientFullName}
              handleDeleteOrder={handleDeleteOrder}
              newlyAddedOrders={newlyAddedOrders}
              getStatusInfo={getStatusInfo}
              handleCallStatusChange={handleCallStatusChange}
            />
          );
        })}
      </div>

      {/* Mobile Summary Footer */}
      <div className="lg:hidden border-t border-gray-200 bg-gray-50 rounded-b-lg overflow-hidden mt-4">
        <div className="px-4 py-3">
          <button 
            onClick={toggleFooterExpand}
            className="flex items-center w-full justify-between text-sm font-medium text-gray-700"
          >
            <span>Résumé des commandes ({orders.length})</span>
            {isFooterExpanded ? (
              <svg className="h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M14.707 12.707a1 1 0 01-1.414 0L10 9.414l-3.293 3.293a1 1 0 01-1.414-1.414l4-4a1 1 0 011.414 0l4 4a1 1 0 010 1.414z" clipRule="evenodd" />
              </svg>
            ) : (
              <svg className="h-5 w-5 text-gray-500" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20" fill="currentColor">
                <path fillRule="evenodd" d="M5.293 7.293a1 1 0 011.414 0L10 10.586l3.293-3.293a1 1 0 111.414 1.414l-4 4a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414z" clipRule="evenodd" />
              </svg>
            )}
          </button>
        </div>

        {isFooterExpanded && (
          <div className="px-4 py-3 space-y-3 border-t border-gray-200">
            <div className="flex justify-between">
              <span className="text-sm font-medium text-gray-500">Total HT</span>
              <span className="text-sm font-medium text-gray-900">
                {formatPrice(orders.reduce((sum, order) => sum + (parseFloat(order.totalHt) || 0), 0))}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-sm font-medium text-gray-500">Total TVA</span>
              <span className="text-sm font-medium text-gray-900">
                {formatPrice(orders.reduce((sum, order) => sum + (parseFloat(order.totalTva) || 0), 0))}
              </span>
            </div>
            <div className="flex justify-between">
              <span className="text-sm font-medium text-gray-500">Frais de livraison</span>
              <span className="text-sm font-medium text-gray-900">
                {formatPrice(orders.reduce((sum, order) => sum + (
                  parseFloat(order.fraisDeLivraison) || 
                  parseFloat(order.fraisLivraison) || 
                  parseFloat(order.fraisTransport) || 
                  {/* empty placeholder removed */}
                ), 0))}
              </span>
            </div>
            <div className="flex justify-between pt-2 border-t border-gray-200">
              <span className="text-sm font-bold text-gray-900">TOTAL TTC</span>
              <span className="text-sm font-bold text-gray-900">
                {formatPrice(orders.reduce((sum, order) => sum + (parseFloat(order.totalTTC) || 0), 0))}
              </span>
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default MobileOrderList;